var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysioFitness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.568 12.168C33.6534 12.168 35.344 10.4954 35.344 8.43204C35.344 6.36871 33.6534 4.69604 31.568 4.69604C29.4826 4.69604 27.792 6.36871 27.792 8.43204C27.792 10.4954 29.4826 12.168 31.568 12.168Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.872 10.456L14.84 15.432C14.84 15.432 13.608 16.72 12.112 15.432C11.792 14.84 11.2 13.88 12.592 12.592C13.984 11.304 18.48 6.76001 18.48 6.76001C18.48 6.76001 19.816 5.31201 21.32 6.76001C22.824 8.20801 25.816 11.256 25.816 11.256C25.816 11.256 27.048 12.216 26.352 13.56C25.92 14.04 24.48 15.008 23.248 13.776C22.008 12.544 19.872 10.456 19.872 10.456Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.688 15.536V18.32H33.416C33.416 18.32 35.288 18.64 35.128 20.032C35.072 20.248 35.448 21.32 33.52 21.64C31.592 21.584 25.648 21.584 25.648 21.584C25.648 21.584 24.472 21.584 24.52 20.088C24.568 18.592 24.624 18.432 24.624 18.432L27.688 15.536Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.136 25.28L7.82396 34.704C7.82396 34.704 6.43196 35.88 5.14396 34.6C4.71196 33.904 4.28796 32.992 5.78396 31.552C7.27996 30.112 14.456 22.88 14.456 22.88L17.136 25.28Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.192 19.984L26.024 25.768C26.024 25.768 27.68 27.536 25.808 29.032C23.504 30.368 18.416 33.152 18.416 33.152C18.416 33.152 16.544 33.952 15.736 32.296C15.632 31.76 15.144 30.64 16.808 29.672C18.464 28.712 21.896 26.992 21.896 26.992L17.128 22.224C17.128 22.224 16.536 20.616 17.288 19.704C17.832 19.232 18.904 18.648 20.192 19.984Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysioFitness);
export default __webpack_public_path__ + "static/media/PhysioFitness.f85364bed5836334b818174e3efba792.svg";
export { ForwardRef as ReactComponent };